import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto'
  },

  greyText: {
    color: 'lightgrey'
  },

  buttonRoot: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '1rem'
  },

  button: {
    padding: '0 0.5rem'
  }
}))

export default useStyles
